import Aside from './aside';
import AsideContainer from './asideContainer';
import Editable from "./editable";

class AsideWebArticles extends Editable {
  // static create(value) {
  //   console.log('asideWebArticles create');
  //   const node = super.create(value);
  //   node.setAttribute('contenteditable', false);
  //   return node;
  // }
  
  constructor(scroll, domNode, articles) {
    console.log('asideWebArticles constructor');
    
    super(scroll, domNode);
    this.articles = articles;
    this.selected = articles.map(article => article.url);
    
    // статьи
    const container = document.createElement('div');
    container.className = 'container-list';
    this.domNode.appendChild(container);
    
    this.grid = document.createElement('ul');
    // this.grid.className = 'list';
    container.appendChild(this.grid);
    
    // контейнер для режима редактирования
    const editContainer = document.createElement('div');
    editContainer.className = 'container-edit';
    this.domNode.appendChild(editContainer);
    
    const editButtons = document.createElement('div');
    editButtons.className = 'buttons';
    editButtons.innerText = 'Управление блоком';
    editContainer.appendChild(editButtons);
  
    this.btnSave = document.createElement('button');
    this.btnSave.setAttribute('type', 'button');
    this.btnSave.innerText = 'Сохранить';
    this.btnSave.addEventListener('click', this.changeMode.bind(this));
    editButtons.appendChild(this.btnSave);
    
    this.btnDestroy = document.createElement('button');
    this.btnDestroy.setAttribute('type', 'button');
    this.btnDestroy.innerText = 'Удалить';
    this.btnDestroy.addEventListener('click', this.remove.bind(this));
    editButtons.appendChild(this.btnDestroy);
    
    this.editGrid = document.createElement('div');
    editContainer.appendChild(this.editGrid);
    
    const onRemove = this.removeSelectedArticle.bind(this);
    
    editContainer.addEventListener('click', function(e) {
      if (e.target && e.target.classList.contains('ql-article-card-remove')) {
        const url = e.target.dataset.url;
        onRemove(url);
      }
    });
    
    // кнопка переключения между режимами
    const btnMode = document.createElement('button');
    btnMode.setAttribute('type', 'button');
    btnMode.className = 'btn-mode';
    btnMode.innerText = 'Редактировать';
    btnMode.addEventListener('click', this.changeMode.bind(this));
    this.domNode.appendChild(btnMode);
  
  
    const searchContainer = document.createElement('div');
    
    const onFetchCallback = this.addSelectedArticle.bind(this);
    const searchField = document.createElement('textarea');
    searchField.classList.add('ql-article-search');
    searchField.setAttribute('tabindex', '-1');
    searchField.setAttribute('placeholder', 'Поиск статей по названию');
    searchField.autofocus = true;
    searchField.onchange = function(e) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', API_DOMAIN + '/api/v0/web-article/search?url='+e.target.value, true);
      xhr.onload = () => {
        if (xhr.status === 200) {
          const article = JSON.parse(xhr.responseText);
          onFetchCallback(article);
        }
      };
      xhr.send(null);
    };
  
    const previewList = document.createElement('ul');
    previewList.classList.add('list');
    
    searchContainer.appendChild(searchField);
    
    this.editGrid.appendChild(this.domCursor);
    this.editGrid.appendChild(searchContainer);
    this.editGrid.appendChild(previewList);
  
    this.previewList = previewList;
    this.searchContainer = searchContainer;
  
    this.editMode = !this.articles.length;
    this.updateEditable();
  }
  
  attach() {
    super.attach();
    this.searchContainer.addEventListener('click', this.handleFocus.bind(this));
    this.attachFieldEvents(this.searchContainer);
  }
  
  changeMode() {
    this.editMode = !this.editMode;
    this.updateEditable();
  }
  
  updateGrid() {
    this.grid.innerHTML = '';
    this.articles.map(article => {
      this.grid.appendChild(AsideWebArticles.createMarkup(article));
    });
  }
  
  updateEditGrid() {
    this.previewList.innerHTML = '';

    this.articles.map(article => {
      this.previewList.appendChild(AsideWebArticles.createEditMarkup(article));
    });
    
    if (this.articles.length) {
      this.btnSave.style.display = 'block';
      this.btnDestroy.style.display = 'none';
    } else {
      this.btnSave.style.display = 'none';
      this.btnDestroy.style.display = 'block';
    }
  }
  
  refreshGrid() {
    if (this.editMode) {
      this.updateEditGrid();
    } else {
      this.updateGrid();
    }
  }
  
  updateEditable() {
    this.domNode.classList.toggle('edit', this.editMode);
    this.refreshGrid();
  }
  
  // static value(domNode) {
  //   const list = domNode.querySelector('.container-list') || domNode;
  //   return Array.prototype.map.call(list, el => el.dataset.url);
  // }
  
  static createMarkup(article) {
    const element = document.createElement('li');
    element.innerHTML = `<div class="article-card" data-url="${article.url}">
      <img class="article-card-image" src="${article.image}">
      ${article.title}
    </div>`.replace(/(\r\n\s+|\n\s+|\r\s+)/gm, '');
    
    return element;
  }
  
  static createEditMarkup(article) {
    const element = document.createElement('li');
    element.innerHTML = `<div class="ql-article-card" data-url="${article.url}">
      <figure class="ql-article-card-media">
        <img class="ql-article-card-image" src="${article.image}">
      </figure>
      <div class="h6 ql-article-card-title">${article.title}</div>
      <span class="ql-article-card-remove" title="убрать" data-url="${article.url}">х</span>
    </div>`.replace(/(\r\n\s+|\n\s+|\r\s+)/gm, '');
    
    return element;
  }
  
  addSelectedArticle(article) {
    if (this.selected.indexOf(article.url) === -1) {
      const oldSelected = this.selected.join('|');
      this.articles.push(article);
      this.selected.push(article.url);
      
      this.updateCache(oldSelected, this.selected.join('|'));
    }
    this.refreshGrid();
  }
  
  removeSelectedArticle(url) {
    const oldSelected = this.selected.join('|');
    this.articles = this.articles.filter(article => article.url !== url );
    this.selected.splice(this.selected.indexOf(url), 1);
    this.updateCache(oldSelected, this.selected.join('|'));
    this.refreshGrid();
  }
  
  updateCache(oldKey, newKey) {
    if (oldKey === newKey) {
      return;
    }
    
    oldKey && AsideContainer._webArticleCache.remove(oldKey);
    newKey && AsideContainer._webArticleCache.set(newKey, this);
  }
}

AsideWebArticles.tagName = 'DIV';
AsideWebArticles.blotName = 'asideWebArticles';
AsideWebArticles.className = 'aside-web-articles';
AsideWebArticles.requiredContainer = Aside;

export default AsideWebArticles;